export default __webpack_public_path__ + "static/media/botoes_laterais_02.c537f657.mp3";